import React, { Component }  from 'react';

class Workflows extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			active: false, 
			intent: false,
			loading: false,
		};
	}
	
	activate = (intent) => (e) => {
		this.setState({intent: intent})
	}
	
	cancel = () => {
		this.setState({intent: false, loading: false, setting: false})
	}
	
	componentWillReceiveProps(nextProps) {
		if(this.state.loading) {
			this.cancel();
		}
	}
	render() {
		if (this.props.active) {
			
			var intentList = []
				for (var intent of this.props.data.Workflows) {
					intentList.push(
						<div className="dataRow"  key={intent.intent} onClick={this.activate(intent)}>
							<span style={{flex: '0 0 300px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}} >{intent.intent}</span>
							<span style={{flex: '1 0 300px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}} >{intent.description}</span>
							<span style={{flex: '1 0 20%', textAlign: 'center'}}>{'Examples: (' + intent.examples.length +')'}</span>
						</div>
					)
				}
				

				
			var activeIntent = ""
			if (this.state.intent) {
				var values = []
				for(var val of this.state.intent.examples){
					values.push(
						<div style={{ padding: '15px'}} key={val.text}>
							<div style={{textAlign: 'left'}}>{val.text}</div>
						</div>
					)
				}
				
				activeIntent = (
					<div className="blackout" tabIndex="1" autoFocus>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}>X</div>
							<div>Viewing details for Intent: </div>
							<div style={{fontSize: '1.3em'}}>{this.state.intent.intent}</div>
							<br/>
							<div style={{fontSize: '1.1em'}}>Examples:</div>
							{values}
							
							<div className="error" style={{padding: '15px'}}>{this.state.error}</div>
							
							{this.state.loading ? <div className="loader"></div> : <div className="button"  onClick={this.cancel}>Confirm Intent</div>}
						</div>
					</div>
				)
			}
			return (
				<div className="viewContent" >
					<div className="dataHeaders">
						<span style={{flex: '0 0 300px', cursor: 'pointer'}} onClick={this.sort} data-sortBy="enabled">Intent Name</span>
						<span style={{flex: '1 0 300px', cursor: 'pointer'}} onClick={this.sort} data-sortBy="modified">Intent Description</span>
						<span style={{flex: '1 0 20px', cursor: 'pointer', textAlign: 'center'	}} onClick={this.sort} data-sortBy="name">Number of Examples</span>
					</div> 
					<div style={{overflow: 'auto', height: 'calc(100% - 40px)'}}>
						{intentList}
							{activeIntent}
					</div>
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

export default Workflows


// WEBPACK FOOTER //
// ./src/Views/Workflows.js